import { yupResolver } from "@hookform/resolvers/yup";
import { Text, VStack } from "native-base";
import React from "react";
import { useForm } from "react-hook-form";
import { TextInputMask } from "react-native-masked-text";
import * as yup from "yup";

import FormButton from "@/components/atoms/FormButton";
import TextInput from "@/components/atoms/TextInput";
import FormField from "@/components/molecules/FormField";
import Modal from "@/components/molecules/Modal";

import { FallbackContact, ModalPropos } from "../types";

const FallbackContactModal = ({
  isOpen,
  currentValue,
  onClose,
  onSubmit,
}: ModalPropos<FallbackContact>) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FallbackContact>({
    resolver: yupResolver(
      yup.object({
        name: yup.string().required("Nome é obrigatório"),
        phone: yup.string().required("Telefone é obrigatório"),
        description: yup.string(),
      })
    ),
    defaultValues: {
      name: currentValue?.name,
      phone: currentValue?.phone,
      description: currentValue?.description,
    },
  });

  const submitContact = (contact: FallbackContact) => {
    onSubmit(contact);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      Header="Contato para troca de produtos"
      Body={
        <VStack mb="2">
          <Text fontSize="md" textAlign="center" py="4">
            Em casos de falta de produtos entraremos em contato para efetuar a troca. Deixe nos
            campos abaixo o nome e telefone com Whatsapp da pessoa que deveremos contatar.
          </Text>
          <FormField
            control={control}
            name="name"
            label="Nome"
            required
            error={errors.name}
            render={(value, onChange) => (
              <TextInput value={value} onChangeText={onChange} placeholder="Nome" />
            )}
          />
          <FormField
            control={control}
            name="phone"
            label="Telefone"
            required
            error={errors.phone}
            render={(value, onChange) => (
              <TextInputMask
                value={value}
                onChangeText={onChange}
                customTextInput={TextInput}
                type={"cel-phone"}
                options={{
                  maskType: "BRL",
                  withDDD: true,
                  dddMask: "(99) ",
                }}
                placeholder="Telefone"
              />
            )}
          />
          <FormField
            control={control}
            name="description"
            label="Observação"
            error={errors.description}
            render={(value, onChange) => (
              <TextInput value={value} onChangeText={onChange} placeholder="Observação" />
            )}
          />
        </VStack>
      }
      Footer={
        <VStack w="full">
          <FormButton mt="4" onPress={handleSubmit(submitContact)}>
            Continuar
          </FormButton>
          <FormButton
            colorScheme="white"
            textColor="primary.700"
            my="4"
            shadow="2"
            onPress={onClose}>
            Cancelar
          </FormButton>
        </VStack>
      }
    />
  );
};

export default FallbackContactModal;
